export const operationsHelper = {
	minHitCal,
	maxHitCal,
	normalize_array,
	minRelatedness,
	maxRelatedness,
	minRelatednessPositive,
	maxRelatednessPositive,
	minRelatednessNegative,
	maxRelatednessNegative,
	cleanHTMLTags,
	hightlightDates,
	highlightWords,
	highlightEmails,
	highlightConcepts,
	getDocumentType,
	hideForSpecificWord,
	getTagColor,
	filteringDocsBayTag,
	hightlightDatesInDocument,
}

function filteringDocsBayTag(doc_list, tag_filter) {
	let newData = []
	if (doc_list.data && doc_list.data.length > 0) {
		try {
			if (tag_filter !== "" && tag_filter !== undefined) {
				if (tag_filter === "untaged") {
					newData = doc_list.data.filter((doc) => doc.hasOwnProperty("tags") === false)
				} else {
					newData = doc_list.data.filter((doc) => doc?.tags === tag_filter)
				}
			} else {
				newData = doc_list.data
			}
		} catch (e) {}
	} else {
		newData = doc_list.data
	}
	return newData
}

function getTagColor(tag_id, tagsApi) {
	let aux_tag = tagsApi.tags.filter((elementTag) => elementTag.id === tag_id)
	if (aux_tag.length === 1) {
		return aux_tag[0].color_id
	} else {
		return "#E2E2E2"
	}
}

function getDocumentType(documentType) {
	if (documentType === "word") {
		return { __html: `<span className="font10"><i className="bi bi-file-earmark-word"></i> Word document</span>` }
	} else {
		if (documentType.substring(documentType.lastIndexOf(".") + 1).includes("doc")) {
			return { __html: `<span className="font10"><i className="bi bi-file-earmark-word"></i> Word document</span>` }
		}
	}

	if (documentType === "excel") {
		return { __html: `<span className="font10"><i className="bi bi-file-earmark-excel"></i> Excel spreadsheet</span>` }
	} else {
		if (documentType.substring(documentType.lastIndexOf(".") + 1).includes("xls")) {
			return { __html: `<span className="font10"><i className="bi bi-file-earmark-excel"></i> Excel spreadsheet</span>` }
		}
	}

	if (documentType === "powerpoint") {
		return { __html: `<span className="font10"><i className="bi bi-file-earmark-ppt"></i> Powerpoint document</span>` }
	} else {
		if (documentType.substring(documentType.lastIndexOf(".") + 1).includes("ppt")) {
			return { __html: `<span className="font10"><i className="bi bi-file-earmark-ppt"></i> Powerpoint document</span>` }
		}
	}

	if (documentType === "pdf") {
		return { __html: `<span className="font10"><i className="bi bi-file-earmark-pdf"></i> PDF document</span>` }
	} else {
		if (documentType.substring(documentType.lastIndexOf(".") + 1).includes("pdf")) {
			return { __html: `<span className="font10"><i className="bi bi-file-earmark-pdf"></i> PDF document</span>` }
		}
	}

	if (documentType === "textfile") {
		return { __html: `<span className="font10"><i className="bi bi-file-earmark-text"></i> Textfile</span>` }
	} else {
		if (
			documentType.substring(documentType.lastIndexOf(".") + 1).includes("txt") ||
			documentType.substring(documentType.lastIndexOf(".") + 1).includes("log")
		) {
			return { __html: `<span className="font10"><i className="bi bi-file-earmark-text"></i> Textfile</span>` }
		}
	}

	if (documentType === "email") {
		return { __html: `<span className="font10"><i className="bi bi-envelope"></i> E-mail</span>` }
	} else {
		if (documentType.substring(documentType.lastIndexOf(".") + 1).includes("@")) {
			return { __html: `<span className="font10"><i className="bi bi-envelope"></i> E-mail</span>` }
		}
	}
}

function hightlightDates(text, id) {
	let replacesDates = []
	let dates1 = text.match(/\d{2}(\D)\d{2}\1\d{4}/g)
	let dates2 = text.match(/\d{2}(\D)\d{2}\1\d{2}/g)
	let dates3 = text.match(/\d{2}([\/.-])\d{2}\1\d{4}/g)
	if (dates1 !== null) {
		for (var i = 0; i < dates1.length; i++) {
			if (!replacesDates.includes(dates1[i])) {
				text = text.replaceAll(
					dates1[i],
					`<mark id="mark_${id}" class="mark mark_date mark_element markPadding">${dates1[i]}</mark>`
				)
				replacesDates.push(dates1[i])
			}
		}
	}

	if (dates2 !== null) {
		for (var i = 0; i < dates2.length; i++) {
			if (!replacesDates.includes(dates2[i])) {
				text = text.replaceAll(
					dates2[i],
					`<mark id="mark_${id}" class="mark mark_date mark_element markPadding">${dates2[i]}</mark>`
				)
				replacesDates.push(dates2[i])
			}
		}
	}

	if (dates3 !== null) {
		for (var i = 0; i < dates3.length; i++) {
			if (!replacesDates.includes(dates3[i])) {
				text = text.replaceAll(
					dates3[i],
					`<mark id="mark_${id}" class="mark mark_date mark_element markPadding">${dates3[i]}</mark>`
				)
				replacesDates.push(dates3[i])
			}
		}
	}

	//Replace othe type of dates

	dates1 = text.match(
		/(((1[0-2]|0?[1-9])\/(3[01]|[12][0-9]|0?[1-9])\/(?:[0-9]{2})?[0-9]{2})|((Jan(uary)?|Feb(ruary)?|Mar(ch)?|Apr(il)?|May|Jun(e)?|Jul(y)?|Aug(ust)?|Sep(tember)?|Oct(ober)?|Nov(ember)?|Dec(ember)?)\s+\d{1,2},\s+\d{4}))/gi
	)

	if (dates1 !== null) {
		for (var i = 0; i < dates1.length; i++) {
			if (!replacesDates.includes(dates1[i])) {
				text = text.replaceAll(
					dates1[i],
					`<mark id="mark_${id}" class="mark mark_date mark_element markPadding">${dates1[i]}</mark>`
				)
				replacesDates.push(dates1[i])
			}
		}
	}
	return text
}

function highlightEmails(text, id) {
	var emails = text.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi)
	let replacesEmail = []
	if (emails !== null) {
		for (var i = 0; i < emails.length; i++) {
			if (!replacesEmail.includes(emails[i])) {
				text = text.replaceAll(
					emails[i],
					`<mark id="mark_${id}" class="mark mark_email mark_element markPadding">${emails[i]}</mark>`
				)
				replacesEmail.push(emails[i])
			}
		}
	}
	return text
}

function highlightWords(content, searchword, id) {
	if (!searchword) {
		return content
	}
	content = content.replaceAll("\n", "")

	let replacesWords = []
	searchword?.forEach((element) => {
		if (element !== " " && element !== "") {
			if (element.toLowerCase().replaceAll('"', "") === "class") {
				//Expecial isue with class="
				var arr = 'class="'
				content = content.replaceAll(arr, "change_tag_c_control123")

				arr = ["class"]
				content = content.replace(
					new RegExp("\\b(" + arr.join("|") + ")\\b", "gi"),
					'<mark tabindex="-1" class="mark mark_word mark_element markPadding">$1</mark>'
				)

				arr = ["change_tag_c_control123"]
				content = content.replaceAll(arr, 'class="')
			} else if (element.toLowerCase().replaceAll('"', "") === "mark") {
				//Expecial isue with <mark
				var arr = "<mark"
				content = content.replaceAll(arr, "change_tag_c_control1234")
				//Expecial isue with "mark mark_concept mark_element"
				var arr2 = '"mark'
				content = content.replaceAll(arr2, "change_tag_c_control456")
				var arr22 = "mark_word"
				content = content.replaceAll(arr22, "change_tag_c_control22")
				var arr222 = 'mark_element">'
				content = content.replaceAll(arr222, "change_tag_c_control33")
				var arr2222 = "mark_concept"
				content = content.replaceAll(arr2222, "change_tag_c_control44")
				//Expecial isue with </mark>
				var arr3 = "</mark>"
				content = content.replaceAll(arr3, "change_tag_c_control789")

				arr = ["mark"]
				content = content.replace(
					new RegExp("\\b(" + arr.join("|") + ")\\b", "gi"),
					'<mark tabindex="-1" class="mark mark_word mark_element markPadding">$1</mark>'
				)

				arr = "change_tag_c_control1234"
				arr2 = "change_tag_c_control456"
				arr22 = "change_tag_c_control22"
				arr222 = "change_tag_c_control33"
				arr2222 = "change_tag_c_control44"
				arr3 = "change_tag_c_control789"
				content = content.replaceAll(arr, "<mark")
				content = content.replaceAll(arr2, '"mark')
				content = content.replaceAll(arr22, "mark_word")
				content = content.replaceAll(arr222, 'mark_element">')
				content = content.replaceAll(arr2222, "mark_concept")
				content = content.replaceAll(arr3, "</mark>")
			} else {
				//content = content.replaceAll(element, `<mark  id="mark_${id}" class="mark mark_word mark_element">${element}</mark>`);
				var arr = [preg_quote(element.replaceAll('"', ""))]
				const specialCharacter = /[ `!@#$%^&Wæøå*()_+\-=\[\]{};':"\\|,.<>\/?~]/
				if (specialCharacter.test(arr)) {
					content = content.replace(
						new RegExp("(" + arr.join("|") + ")", "gi"),
						'<mark tabindex="-1" class="mark markPadding mark_word mark_element">$1</mark>'
					)
				} else {
					content = content.replace(
						new RegExp("\\b(" + arr.join("|") + ")\\b", "gi"),
						'<mark tabindex="-1" class="mark markPadding mark_word mark_element">$1</mark>'
					)
				}
			}
		}
		/*
          const words1 = content.match(/for/gi);
          if (words1 !== null){
            for (var i=0; i<words1.length; i++){
              if (!replacesWords.includes(words1[i])){
                content = content.replace(words1[i], `<mark  id="mark_${id}" className="mark mark_word">${words1[i]}</mark>`);
                replacesWords.push(words1[i]);
              }
            }
          }*/
	})

	return content
}
function preg_quote(str, delimiter) {
	// eslint-disable-line camelcase
	return (str + "").replace(new RegExp("[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\" + (delimiter || "") + "-]", "g"), "\\$&")
}

function cleanHTMLTags(content) {
	if (content === null || content === undefined) {
		return ""
	}
	return content
		.replace(/&/g, "&amp;")
		.replace(/>/g, "&gt;")
		.replace(/</g, "&lt;")
		.replace(/"/g, "&quot;")
		.replaceAll("\r\n", "\n")
		.replaceAll("\r", "\n")
		.replaceAll("\\n", "\n")
		.replace(/[\n]/g, "<br />")
}

function highlightConcepts(content, concepts, id, searchWords = "") {
	if (content == "") {
		return content
	}
	content = content.replaceAll("\n", "")
	var matches = /".+?"/.exec(searchWords)
	searchWords = searchWords.toString().replace(/".+?"/, "")
	//searchWords=searchWords.replace(/^s+|s+$/g, "");
	var astr = searchWords.split(" ")
	if (matches) {
		for (var i = 0; i < matches.length; i++) {
			astr.push(matches[i].replace(/"/g, ""))
		}
	}
	concepts = concepts.concat(astr)

	if (concepts.length === 0) {
		return content
	}
	concepts = [...new Set(concepts)]
	let replacesWords = []
	concepts.forEach((element) => {
		if (element !== " " && element !== "" && element !== '"') {
			if (element.toLowerCase().replaceAll('"', "") === "class") {
				//Expecial isue with class="
				var arr = 'class="'
				content = content.replace(arr, "change_tag_c_control123")

				arr = ["class"]
				content = content.replace(
					new RegExp("\\b(" + arr.join("|") + ")\\b", "gi"),
					'<mark class="mark mark_concept mark_element">$1</mark>'
				)

				arr = "change_tag_c_control123"
				content = content.replace(arr, 'class="')
			} else if (element.toLowerCase().replaceAll('"', "") === "mark") {
				//return content;
				//Expecial isue with <mark
				var arr = "<mark"
				content = content.replaceAll(arr, "change_tag_c_control1234")
				//Expecial isue with "mark mark_concept mark_element"
				var arr2 = '"mark'
				content = content.replaceAll(arr2, "change_tag_c_control456")
				var arr22 = "mark_concept"
				content = content.replaceAll(arr22, "change_tag_c_control22")
				var arr222 = 'mark_element">'
				content = content.replaceAll(arr222, "change_tag_c_control33")
				var arr2222 = "mark_word"
				content = content.replaceAll(arr2222, "change_tag_c_control44")
				//Expecial isue with </mark>
				var arr3 = "</mark>"
				content = content.replaceAll(arr3, "change_tag_c_control789")

				arr = ["mark"]

				content = content.replace(
					new RegExp("\\b(" + arr.join("|") + ")\\b", "gi"),
					'<mark class="mark mark_concept mark_element">$1</mark>'
				)
				arr = "change_tag_c_control1234"
				arr2 = "change_tag_c_control456"
				arr22 = "change_tag_c_control22"
				arr222 = "change_tag_c_control33"
				arr2222 = "change_tag_c_control44"
				arr3 = "change_tag_c_control789"
				content = content.replaceAll(arr, "<mark")
				content = content.replaceAll(arr2, '"mark')
				content = content.replaceAll(arr22, "mark_concept")
				content = content.replaceAll(arr222, 'mark_element">')
				content = content.replaceAll(arr2222, "mark_word")
				content = content.replaceAll(arr3, "</mark>")
			} else {
				var arr = [preg_quote(element.replaceAll('"', ""))]
				console.log(arr)
				const specialCharacter = /[ `!@#$%^&Wæøå*()_+\-=\[\]{};':"\\|,.<>\/?~]/
				if (specialCharacter.test(arr)) {
					content = content.replace(
						new RegExp("(" + arr.join("|") + ")", "gi"),
						'<mark class="mark mark_concept mark_element">$1</mark>'
					)
				} else {
					content = content.replace(
						new RegExp("\\b(" + arr.join("|") + ")\\b", "gi"),
						'<mark class="mark mark_concept mark_element">$1</mark>'
					)
				}
			}
		}
	})

	return content
}

function capitalizeFirstLetter(string) {
	return string.charAt(0).toUpperCase() + string.slice(1)
}

function minHitCal(terms) {
	const res = terms.map((x) => x[0])
	return Math.min.apply(null, res)
}

function maxHitCal(terms) {
	const res = terms.map((x) => x[0])
	return Math.max.apply(null, res)
}

function minRelatedness(terms) {
	const res = terms.map((x) => x[2])
	return Math.min.apply(null, res)
}

function minRelatednessPositive(terms) {
	const res = terms.map((x) => (x[2] > 0 ? x[2] : null))
	return Math.min.apply(null, res)
}

function minRelatednessNegative(terms) {
	const res = terms.map((x) => (x[2] < 0 ? Math.abs(x[2]) : null))
	return Math.min.apply(null, res)
}

function maxRelatedness(terms) {
	const res = terms.map((x) => x[2])
	return Math.max.apply(null, res)
}

function maxRelatednessPositive(terms) {
	const res = terms.map((x) => (x[2] > 0 ? x[2] : null))
	return Math.max.apply(null, res)
}

function maxRelatednessNegative(terms) {
	const res = terms.map((x) => (x[2] < 0 ? Math.abs(x[2]) : null))
	return Math.max.apply(null, res)
}

function normalize_array(arr) {
	const min1 = Math.min(...arr)
	function tractor(this_num) {
		return this_num - min1
	}
	let arr1 = arr.map(tractor)
	const max2 = Math.max(...arr1)
	function divider(this_num) {
		return this_num / max2
	}
	let arr2 = arr1.map(divider)
	function multiplier(this_num) {
		return this_num * 4
	}
	let arr3 = arr2.map(multiplier)
	function adder(this_num) {
		return this_num + 2
	}
	let arr4 = arr3.map(adder)
	return arr4
}

//Hide eleement if filter from exclude specific word is active
function hideForSpecificWord(content, specificWordExclude, searchWordExclude) {
	let excludeContent = false
	if (specificWordExclude === false || searchWordExclude.length === 0) {
		return false
	} else {
		//Need to find words on filter
		let words = searchWordExclude[0]
		for (var i = 0; i < words.length; i++) {
			if (words[i] !== "" && words[i] !== " ") {
				if (content.toUpperCase().indexOf(words[i].toUpperCase()) !== -1) {
					excludeContent = true
					break
				}
			}
		}
	}
	return excludeContent
}

function hightlightDatesInDocument(content, id) {
	let replacesDates = []
	// let regex1 = /\d{2}(\D)\d{2}\1\d{4}/g
	// let regex2 = /\d{2}(\D)\d{2}\1\d{4}/g

	//dd/mm/yyyy
	let regex1 = /^(0[1-9]|1\d|2\d|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d{2}$/

	//dd-mm-yyyy
	let regex2 = /^(0[1-9]|1\d|2\d|3[01])\-(0[1-9]|1[0-2])\-(19|20)\d{2}$/

	//mm/dd/yyyy
	let regex3 = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/

	//yyyy.MM.dd
	let regex4 = /^((19|20)\d{2})\.(0[1-9]|1[0-2])\.(0[1-9]|1\d|2\d|3[01])$/

	//yyyy/MM/dd
	let regex5 = /^((19|20)\d{2})\/(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])$/

	//yyyy-MM-dd
	let regex6 = /^((19|20)\d{2})\-(0[1-9]|1[0-2])\-(0[1-9]|1\d|2\d|3[01])$/

	//February 17, 2023
	let regex7 =
		/(((Jan(uary)?|Feb(ruary)?|Mar(ch)?|Apr(il)?|May|Jun(e)?|Jul(y)?|Aug(ust)?|Sep(tember)?|Oct(ober)?|Nov(ember)?|Dec(ember)?).?\s+\d{1,2},\s+\d{4}))/gi //February 17, 2023

	//dd.mm.yyyy
	let regex8 = /^(0[1-9]|1\d|2\d|3[01])\.(0[1-9]|1[0-2])\.(19|20)\d{2}$/

	//12. May, 2022
	let regex9 = /^(([0-9])|([0-2][0-9])|([3][0-1]))\. *(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\, \d{4}$/

	//12 may 2000
	let regex10 = /^(([0-9])|([0-2][0-9])|([3][0-1]))\ *(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\ \d{4}$/ //12 may 2000

	//may 2000
	let regex11 =
		/((Jan(uary)?|Feb(ruary)?|Mar(ch)?|Apr(il)?|May|Jun(e)?|Jul(y)?|Aug(ust)?|Sep(tember)?|Oct(ober)?|Nov(ember)?|Dec(ember)?)\s+\d{4})/gi //may 2000

	//12. May
	let regex12 = /^(([0-9])|([0-2][0-9])|([3][0-1]))\. *(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)/

	//const allPossibleDateFormatRegex = [regex1, regex2, regex3, regex4, regex5, regex6, regex7, regex8, regex9, regex10, regex11, regex12]

	//dd/mm/yyyy, dd-mm-yyyy, dd.mm.yyyy, d/m/yy
	const regex13 = /\d{1,2}[\/\-\.]\d{1,2}[\/\-\.]\d{2,4}/
	const allPossibleDateFormatRegex = [
		regex1,
		regex2,
		regex3,
		regex4,
		regex5,
		regex6,
		regex7,
		regex8,
		regex9,
		regex10,
		regex11,
		regex12,
		regex13,
	]
	const allDatesToReplace = []
	allPossibleDateFormatRegex?.forEach((regex, index) => {
		let dates = content.match(regex)
		if (dates) {
			allDatesToReplace.push(dates)
		}

		return allDatesToReplace
	})
	let flatArray = [].concat(...allDatesToReplace)
	flatArray?.forEach((dates, index) => {
		if (!replacesDates.includes(dates)) {
			content = content.replaceAll(dates, `<mark class="mark mark_date mark_element markPadding">${dates}</mark>`)
			replacesDates.push(dates)
		}
	})
	return content
}
